import '/lib/promise.polyfill.min.js'
import 'whatwg-fetch'
import '/lib/lodash-4.17.4.min.js'
import '/lib/siema-1.4.9.min.js'
import '/lib/closest.polyfill.js'
import '/lib/url-search-params-polyfill.js'

// import '/lib/jquery-3.2.1.slim.min.js'
// import '/lib/jquery-3.2.1.min.js'
// import '/lib/tweetie.min.js'
import '/lib/instafeed.min.js'
// import '/lib/jquery.basictable-1.0.6.min.js'

// SEE: https://github.com/bfred-it/object-fit-images/blob/c23e54985d82440ef12c8cfda46de2194506fea8/detailed-support-tables.md
import { objectFitImages } from '/lib/ofi-3.2.3.min.js'
import '/lib/picturefill-3.0.2.min.js'
document.addEventListener('DOMContentLoaded', function() {
	objectFitImages()
})
